import { useForm } from "react-hook-form";
import { CHANGE_EMAIL_REQUEST_ROUTE } from "@api-routes/users";
import { getStateToPayload } from "../mappers/updateEmailMapper";
import { useFetch } from "@common/hook/useFetch";

export const useUpdateEmail = (oldEmail: string, callback: () => void) => {
    const [changeEmailState, { post }] = useFetch();
    const formMethods = useForm<{ email: string; emailConfirm: string }>({
        defaultValues: { emailConfirm: "", email: "" },
    });

    const { handleSubmit } = formMethods;

    const handleOnSubmit = handleSubmit((formData) => {
        if (formData.email !== oldEmail) {
            post<boolean>(CHANGE_EMAIL_REQUEST_ROUTE, {
                body: getStateToPayload(formData.email),
            }).then((updateEmailResponse) => {
                if (updateEmailResponse) {
                    callback();
                }
            });
        }
    });

    return { formMethods, handleOnSubmit, changeEmailState };
};
